<section class="painel-filtros-atividades">
    <div class="cabecalho-painel">
        <i class="pi pi-filter"></i>
        <h2>Filtros</h2>
    </div>
    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('codigo')" [attr.aria-expanded]="!blocosColapsados.codigo">
            <h3>Código</h3>
            <i [class]="iconeColapso('codigo')"></i>
        </button>

        @if (!blocosColapsados.codigo) {
            <div class="conteudo-bloco">
                <div class="grupo-radio">
                    @for (opcao of opcoesSelecao; track opcao.valor) {
                        <label class="opcao-radio">
                            <input type="radio" name="selecao-atividade" [value]="opcao.valor" [(ngModel)]="filtrosLocais.tipoSelecao" />
                            <span>{{ opcao.rotulo }}</span>
                        </label>
                    }
                </div>

                @if (filtrosLocais.tipoSelecao !== 'todos') {
                    <label class="campo-unico">
                        <input type="text" [(ngModel)]="filtrosLocais.valorSelecao" placeholder="Digite para filtrar" />
                    </label>
                }
            </div>
        }
    </article>

    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('periodo')" [attr.aria-expanded]="!blocosColapsados.periodo">
            <h3>Período da Atividade</h3>
            <i [class]="iconeColapso('periodo')"></i>
        </button>

        @if (!blocosColapsados.periodo) {
            <div class="conteudo-bloco">
                <div class="subtitulo">Abertura</div>
                <div class="campo-inline periodo">
                    <label>
                        Início
                        <input type="date" [(ngModel)]="filtrosLocais.aberturaInicio" />
                    </label>
                    <label>
                        Fim
                        <input type="date" [(ngModel)]="filtrosLocais.aberturaFim" />
                    </label>
                </div>

                <div class="subtitulo">Encerramento</div>
                <div class="campo-inline periodo">
                    <label>
                        Início
                        <input type="date" [(ngModel)]="filtrosLocais.encerramentoInicio" />
                    </label>
                    <label>
                        Fim
                        <input type="date" [(ngModel)]="filtrosLocais.encerramentoFim" />
                    </label>
                </div>
            </div>
        }
    </article>

    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('situacao')" [attr.aria-expanded]="!blocosColapsados.situacao">
            <h3>Situação da Atividade</h3>
            <i [class]="iconeColapso('situacao')"></i>
        </button>

        @if (!blocosColapsados.situacao) {
            <div class="grupo-radio horizontal conteudo-bloco">
                @for (opcao of opcoesSituacao; track opcao.valor) {
                    <label class="opcao-radio">
                        <input type="radio" name="situacao-atividade" [value]="opcao.valor" [(ngModel)]="filtrosLocais.situacao" />
                        <span>{{ opcao.rotulo }}</span>
                    </label>
                }
            </div>
        }
    </article>

    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('responsavel')" [attr.aria-expanded]="!blocosColapsados.responsavel">
            <h3>Responsável Pela Atividade</h3>
            <i [class]="iconeColapso('responsavel')"></i>
        </button>

        @if (!blocosColapsados.responsavel) {
            <label class="campo-unico">
                Responsável:
                <div class="campo-busca-linha">
                    <input type="text" [value]="descricaoResponsavelSelecionado()" placeholder="Nenhum responsável selecionado" readonly />
                    <button type="button" class="botao-icone" (click)="abrirPesquisaResponsavel()" title="Pesquisar responsável">
                        <i class="pi pi-search"></i>
                    </button>
                    <button type="button" class="botao-icone limpar" (click)="limparResponsavelSelecionado()" [disabled]="!filtrosLocais.responsavelId" title="Limpar responsável">
                        <i class="pi pi-ban"></i>
                    </button>
                </div>
            </label>
        }
    </article>

    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('descricao')" [attr.aria-expanded]="!blocosColapsados.descricao">
            <h3>Descrição da Atividade</h3>
            <i [class]="iconeColapso('descricao')"></i>
        </button>

        @if (!blocosColapsados.descricao) {
            <label class="campo-unico">
                <textarea rows="3" [(ngModel)]="filtrosLocais.descricao"></textarea>
            </label>
        }
    </article>

    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('tipoComissao')" [attr.aria-expanded]="!blocosColapsados.tipoComissao">
            <h3>Tipo de Comissão</h3>
            <i [class]="iconeColapso('tipoComissao')"></i>
        </button>

        @if (!blocosColapsados.tipoComissao) {
            <div class="grupo-radio conteudo-bloco">
                @for (opcao of opcoesTipoComissao; track opcao.valor) {
                    <label class="opcao-radio">
                        <input type="radio" name="tipo-comissao-atividade" [value]="opcao.valor" [(ngModel)]="filtrosLocais.tipoComissao" />
                        <span>{{ opcao.rotulo }}</span>
                    </label>
                }
            </div>
        }
    </article>

    <div class="acoes-filtro">
        <button type="button" pButton [label]="labelBotaoColapso()" severity="secondary" [outlined]="true" (click)="colapsarFiltros()"></button>
        <button type="button" pButton label="Limpar Filtros" severity="secondary" [outlined]="true" (click)="limpar()"></button>
        <button type="button" pButton label="Aplicar Filtros" (click)="aplicar()"></button>
    </div>

    <p-dialog
        appDialogoPadrao="pi pi-check-square"
        descricao="Escolha um item para continuar."
        closeAriaLabel="Fechar"
        [(visible)]="exibirDialogResponsaveis"
        header="Seleção"
        [style]="{ width: '48rem', maxWidth: '96vw' }"
        [breakpoints]="{ '960px': '90vw', '640px': '96vw' }"
        (onHide)="fecharPesquisaResponsavel()"
    >
        <section class="dialog-responsaveis">
            <fieldset class="filtros-pesquisa">
                <legend>Filtros de Pesquisa</legend>
                <div class="filtros-pesquisa-grid">
                    <label class="campo-uf">
                        UF
                        <app-estado-select [uf]="filtroResponsavelUf" (ufChange)="filtroResponsavelUf = $event"></app-estado-select>
                    </label>
                    <label>
                        Nome
                        <input type="text" [ngModel]="filtroResponsavelNome" (ngModelChange)="onFiltroResponsavelNomeChange($event)" />
                    </label>
                    <div class="acoes-pesquisa">
                        <button type="button" class="botao-icone pesquisa" (click)="pesquisarResponsaveisDialog()" title="Pesquisar">
                            <i class="pi pi-search"></i>
                        </button>
                    </div>
                </div>
            </fieldset>

            @if (erroPesquisaResponsaveis()) {
                <div class="alerta-erro-pesquisa">
                    {{ erroPesquisaResponsaveis() }}
                </div>
            }

            <div class="tabela-responsaveis">
                <table>
                    <thead>
                        <tr>
                            <th>UF</th>
                            <th>Nome</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (responsavel of responsaveisPesquisa(); track trackResponsavel($index, responsavel)) {
                            <tr (click)="selecionarResponsavelPesquisa(responsavel)" [class.selecionado]="isResponsavelSelecionado(responsavel)">
                                <td>{{ responsavel.ufSgUf || '-' }}</td>
                                <td>{{ responsavel.nmSolicitante || '-' }}</td>
                            </tr>
                        } @empty {
                            <tr>
                                <td colspan="2" class="sem-registros">Nenhum responsável encontrado.</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>

            @if (carregandoResponsaveisPesquisa()) {
                <div class="status-pesquisa">Carregando responsáveis...</div>
            }
        </section>

        <ng-template pTemplate="footer">
            <button type="button" pButton label="OK" (click)="confirmarPesquisaResponsavel()" [disabled]="!responsavelSelecionadoPesquisa"></button>
            <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="fecharPesquisaResponsavel()"></button>
        </ng-template>
    </p-dialog>
</section>
